<template>
  <div class="usage-dashboard-filters">
    <eg-dropdown
      ref="courseDropdown"
      :text="selectedCourseLabel"
      class="usage-dashboard-filters__dropdown"
    >
      <eg-b-dropdown-item-button
        :active="!courseId"
        @click="$emit('update:courseId', null)"
      >
        All courses
      </eg-b-dropdown-item-button>
      <eg-b-dropdown-item-button
        v-for="course in courses"
        :key="course.id"
        :active="courseId === course.id"
        @click="$emit('update:courseId', course.id)"
      >
        {{ course.name }}
      </eg-b-dropdown-item-button>
    </eg-dropdown>

    <eg-dropdown
      ref="instructorDropdown"
      :text="selectedInstructorLabel"
      class="usage-dashboard-filters__dropdown"
    >
      <eg-b-dropdown-item-button
        :active="!instructorId"
        @click="$emit('update:instructorId', null)"
      >
        All instructors
      </eg-b-dropdown-item-button>
      <eg-b-dropdown-item-button
        v-for="instructor in instructors"
        :key="instructor.id"
        :active="instructorId === instructor.id"
        @click="$emit('update:instructorId', instructor.id)"
      >
        {{ instructor.firstName }} {{ instructor.lastName }}
      </eg-b-dropdown-item-button>
    </eg-dropdown>

    <date-range
      :value="dateRange"
      :reset-signal="resetSignal"
      @input="$emit('update:dateRange', $event)"
    />

    <button
      type="button"
      class="usage-dashboard-filters__reset"
      @click="onReset"
    >
      Reset filters
    </button>
  </div>
</template>

<script>
import DateRange from "@/components/essay/filters/date_range.vue";
import dropdownHideOnLeaveMixin from "@/mixins/dropdownHideOnLeaveMixin";

export default {
  name: "UsageDashboardFilters",

  components: {
    DateRange,
  },

  mixins: [dropdownHideOnLeaveMixin],

  props: {
    courses: {
      type: Array,
      default: () => [],
    },
    instructors: {
      type: Array,
      default: () => [],
    },
    courseId: {
      type: Number,
      default: null,
    },
    instructorId: {
      type: Number,
      default: null,
    },
    dateRange: {
      type: Object,
      default: () => ({ from: "", to: "" }),
    },
  },

  data() {
    return {
      resetSignal: 0,
    };
  },

  computed: {
    selectedCourseLabel() {
      const found = this.courses.find((c) => c.id === this.courseId);
      return found ? found.name : "All courses";
    },

    selectedInstructorLabel() {
      const found = this.instructors.find((i) => i.id === this.instructorId);
      return found ? `${found.firstName} ${found.lastName}` : "All instructors";
    },
  },

  methods: {
    hideDropdowns() {
      this.$refs.courseDropdown?.hide();
      this.$refs.instructorDropdown?.hide();
    },

    onReset() {
      this.resetSignal++;
      this.$emit("reset");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../metrics/components/shared/metrics_card";

.usage-dashboard-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  &__dropdown {
    min-width: 180px;
    @include metrics-dropdown;

    ::v-deep .btn {
      background: var(--color-surface-neutral-background, #fff);
    }
  }

  &__reset {
    border: none;
    background: transparent;
    padding: 8px 4px;
    color: var(--color-text-primary-default, #7c3aed);
    font-family: var(--typography-font-family-text-primary, Inter);
    font-size: var(--typography-font-size-fs-300, 14px);
    font-weight: var(--typography-font-weight-fw-600, 600);
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
